import React from 'react'
import { Link } from 'react-router-dom'
import { format, parseISO } from 'date-fns';

import { formatAddress } from '../../utils/Helper';

const DisplayContractsTable = ({ contracts, showDaysToClosing = true }) => {
    const getStatusColor = (days_to_closure) => {
        if (days_to_closure > 20) {
            return "bg-green-100 text-green-800 border-green-300";
        } else if (days_to_closure > 10) {
            return "bg-yellow-100 text-yellow-800 border-yellow-300";
        } else {
            return "bg-red-100 text-red-800 border-red-300";
        }
    };

    return (
        <>
            {/* Desktop Table View */}
            <div className="hidden md:block overflow-x-auto rounded-lg shadow">
                <table className="w-full table-auto">
                    <thead>
                        <tr className="bg-gradient-to-r from-blue-50 to-blue-100 border-b border-blue-200">
                            <th className="px-6 py-3 text-left text-xs font-semibold text-blue-800 uppercase tracking-wider">
                                Address
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-blue-800 uppercase tracking-wider">
                                Sales Price
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-semibold text-blue-800 uppercase tracking-wider">
                                Closing Date
                            </th>
                            {showDaysToClosing && (
                                <th className="px-6 py-3 text-center text-xs font-semibold text-blue-800 uppercase tracking-wider">
                                    Days to Closing
                                </th>
                            )}
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-100">
                        {contracts.map((contract, index) => {
                            const days_to_closure = Math.round((new Date(contract.closing_date) - new Date()) / 86400000, 0)
                            const statusColor = getStatusColor(days_to_closure);

                            return (
                                <tr key={index} className="hover:bg-blue-50 transition-colors">
                                    <td className="px-6 py-4">
                                        <Link
                                            to={`/contract-details/${contract.contract_id}`}
                                            className="text-blue-600 hover:text-blue-800 font-medium hover:underline"
                                        >
                                            {formatAddress(contract.address, contract.apartment, contract.city, contract.state, contract.zipcode)}
                                        </Link>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        {contract.sale_price && (
                                            <div className="text-right font-medium text-gray-900">
                                                ${new Intl.NumberFormat('en-US').format(contract.sale_price)}
                                            </div>
                                        )}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-gray-700">
                                        {format(parseISO(contract.closing_date), 'MMM dd, yyyy')}
                                    </td>
                                    {showDaysToClosing && (
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="flex justify-center">
                                                <span className={`px-3 py-1 inline-flex text-sm leading-5 font-medium rounded-full ${statusColor}`}>
                                                    {days_to_closure} days
                                                </span>
                                            </div>
                                        </td>
                                    )}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                {contracts.length === 0 && (
                    <div className="text-center py-8 bg-white">
                        <p className="text-gray-500">No contracts found</p>
                    </div>
                )}
            </div>

            {/* Mobile Card View */}
            <div className="md:hidden space-y-4 mt-4">
                {contracts.map((contract, index) => {
                    const days_to_closure = Math.round((new Date(contract.closing_date) - new Date()) / 86400000, 0)
                    const statusColor = getStatusColor(days_to_closure);

                    return (
                        <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
                            <div className="flex justify-between items-start mb-3">
                                <Link
                                    to={`/contract-details/${contract.contract_id}`}
                                    className="text-blue-600 hover:text-blue-800 font-medium text-sm leading-tight"
                                >
                                    {formatAddress(contract.address, contract.apartment, contract.city, contract.state, contract.zipcode)}
                                </Link>
                                {showDaysToClosing && (
                                    <span className={`px-2 py-1 text-xs font-medium rounded-full ${statusColor} ml-2 flex-shrink-0`}>
                                        {days_to_closure} days
                                    </span>
                                )}
                            </div>

                            <div className="grid grid-cols-2 gap-4 text-sm">
                                <div>
                                    <span className="text-gray-500 text-xs">Sales Price</span>
                                    <div className="font-medium text-gray-900">
                                        {contract.sale_price ?
                                            `$${new Intl.NumberFormat('en-US').format(contract.sale_price)}` :
                                            'N/A'
                                        }
                                    </div>
                                </div>
                                <div>
                                    <span className="text-gray-500 text-xs">Closing Date</span>
                                    <div className="font-medium text-gray-700">
                                        {format(parseISO(contract.closing_date), 'MMM dd, yyyy')}
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}

                {contracts.length === 0 && (
                    <div className="text-center py-8 bg-white rounded-lg shadow-sm">
                        <p className="text-gray-500">No contracts found</p>
                    </div>
                )}
            </div>
        </>
    )
}

export default DisplayContractsTable
